/**
 * @file CanvasLoading.tsx
 * @description Заглушка канвы конструктора, пока сайт грузится (phase19.16
 * Р1-6а; uiux-builder-shell.md §6): заготовка страницы и «Загружаем сайт…»;
 * если сайт не ответил за 15 секунд — объяснение и [Повторить]. Новый вход
 * (смена страницы, перерисовка) — новый `key`, таймер начинается заново.
 */

import { RefreshCw } from "lucide-react";
import { useEffect, useState } from "react";

import { Button } from "../../ui/button";
import { Skeleton } from "../../ui/skeleton";

/** Сколько ждать сайт, прежде чем предложить повторить. */
export const CANVAS_SLOW_MS = 15_000;

export function CanvasLoading({ onRetry }: { onRetry: () => void }) {
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setSlow(true), CANVAS_SLOW_MS);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="absolute inset-0 flex flex-col gap-3 bg-surface-lowest p-4" aria-busy={!slow} role="status">
      <Skeleton className="h-10 w-full rounded-lg" />
      <Skeleton className="h-40 w-full rounded-lg" />
      <Skeleton className="h-6 w-2/3 rounded-lg" />
      <Skeleton className="h-6 w-1/2 rounded-lg" />
      <div className="flex flex-col items-center gap-3 pt-2 text-center">
        <p className="type-body max-w-[46ch] text-on-surface-variant">
          {slow ? "Сайт не отвечает дольше 15 секунд. Правки сохраняются — можно продолжать." : "Загружаем сайт…"}
        </p>
        {slow ? (
          <Button variant="outline" onClick={onRetry}>
            <RefreshCw aria-hidden />
            Повторить
          </Button>
        ) : null}
      </div>
    </div>
  );
}
